import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const VendorNameFilter = styled.div(
  ({ theme }) => css`
    border: 1px solid ${theme.GREY_3};
    border-radius: 5px;
    padding: 5px;
    .euiComboBox {
      max-width: 100%;
    }
    .euiFormControlLayout {
      max-width: 100%;
    }
    .euiComboBox__inputWrap.euiComboBox__inputWrap-isClearable {
      max-width: 100%;
    }
    .euiComboBox .euiComboBox__inputWrap {
      border-radius: 10px;
      box-shadow: none;
      background-color: ${theme.WHITE};
    }
    span.euiBadge.euiBadge--hollow.euiBadge--iconRight.euiComboBoxPill {
      background: ${theme.GREY_2};
      border: none;
      border-radius: 20 px;
      padding: 6px 8px;
      height: 32px;
    }
    margin-bottom: 10px;
  `
);
